import { IkasProductAttributeType } from "../../../..";

export type IkasThemeJsonComponentProp = {
  id: string;
  name: string;
  displayName?: string;
  description?: string;
  type: IkasThemeJsonComponentPropType;
  isRequired: boolean;
  customDataId?: string | null;
  groupId?: string;
  requiredPropId?: string;
  requiredEnumOptionId?: string;
  requiredEnumOptionValue?: string;
  attributeTypes?: IkasProductAttributeType[] | null;
  sliderData: IkasThemeJsonSliderData;
  translations?: {
    [locale: string]: IkasPropTranslation;
  };
};

export type IkasThemeJsonSliderData = {
  min?: number;
  max?: number;
  interval?: number;
  unit?: string;
};

export enum IkasThemeJsonComponentPropType {
  TEXT = "TEXT",
  RICH_TEXT = "RICH_TEXT",
  BOOLEAN = "BOOLEAN",
  IMAGE = "IMAGE",
  IMAGE_LIST = "IMAGE_LIST",
  LINK = "LINK",
  LIST_OF_LINK = "LIST_OF_LINK",
  PRODUCT_DETAIL = "PRODUCT_DETAIL",
  PRODUCT_LIST = "PRODUCT_LIST",
  PRODUCT_ATTRIBUTE = "PRODUCT_ATTRIBUTE",
  PRODUCT_ATTRIBUTE_LIST = "PRODUCT_ATTRIBUTE_LIST",
  BRAND = "BRAND",
  BRAND_LIST = "BRAND_LIST",
  CATEGORY = "CATEGORY",
  CATEGORY_LIST = "CATEGORY_LIST",
  COLOR = "COLOR",
  CUSTOM = "CUSTOM",
  COMPONENT = "COMPONENT",
  COMPONENT_LIST = "COMPONENT_LIST",
  BLOG = "BLOG",
  BLOG_LIST = "BLOG_LIST",
  BLOG_CATEGORY = "BLOG_CATEGORY",
  BLOG_CATEGORY_LIST = "BLOG_CATEGORY_LIST",
  RAFFLE = "RAFFLE",
  RAFFLE_LIST = "RAFFLE_LIST",
  SLIDER = "SLIDER",

  OBJECT = "OBJECT",
  STATIC_LIST = "STATIC_LIST",
  DYNAMIC_LIST = "DYNAMIC_LIST",
  ENUM = "ENUM",
}

export type IkasPropTranslation = {
  displayName: string | null;
  description: string | null;
};
